// extracted by mini-css-extract-plugin
module.exports = {"container":"newsletterWidgetTop_container__9YWWJ","widgetText":"newsletterWidgetTop_widgetText__yKs1K","subscribeAndShare":"newsletterWidgetTop_subscribeAndShare__HZpf4"};